import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * Stops `<input type="number">` values from changing when the mouse wheel is
 * scrolled over a focused input.
 *
 * The input is blurred on wheel so the page continues to scroll normally
 * instead of incrementing/decrementing the value. The directive matches native
 * number inputs automatically and can be opted into explicitly (e.g. on shared
 * input components whose `type` is bound dynamically) via the
 * `appPreventNumberScroll` attribute. A runtime check ensures only number
 * inputs are affected.
 */
@Directive({
  selector: 'input[type="number"], input[appPreventNumberScroll]',
  standalone: true,
})
export class PreventNumberScrollDirective {
  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {}

  @HostListener('wheel')
  onWheel(): void {
    const input = this.elementRef.nativeElement;

    if (input.type === 'number' && document.activeElement === input) {
      input.blur();
    }
  }
}
